"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24ZM12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.37,11.39,7.89,3.9a.89.89,0,0,0-.92,0,.91.91,0,0,0-.46.79v15a.91.91,0,0,0,.46.79.89.89,0,0,0,.45.12,1,1,0,0,0,.47-.13L20.37,13a.92.92,0,0,0,.44-.78A.91.91,0,0,0,20.37,11.39Z",
    fill: "#97bf0d"
  }));
};

exports["default"] = _default;